import React from 'react';
import { Container, Text, Heading, Col, Row } from 'design-system';
import { useTranslate } from 'gatsby-theme-soluble-source';
import ButtonComponent from '../ButtonComponent';

import style from './styles.module.scss';

export default function NewsletterSection({ button }) {
    const translation = useTranslate();

    return (
        <section data-datocms-noindex className={style.wrapper}>
            <Container pt={{ xs: 10 }} pb={{ xs: 9 }}>
                <Row className="align-items-lg-center">
                    <Col
                        col={{ lg: 5 }}
                        offset={{ lg: 1 }}
                        pb={{ xs: 5, lg: 0 }}>
                        <Heading tag="h5" className="h3 mb-3 font-weight-bold">
                            {translation['newsletter.title'].text}
                        </Heading>
                        <Text tag="p" className="body">
                            {translation['newsletter.subtitle'].text}
                        </Text>
                    </Col>
                    <Col offset={{ lg: 1 }} col={{ lg: 4, xxl: 3 }}>
                        {button ? (
                            <ButtonComponent
                                dark={true}
                                button={{
                                    type: 'primary-xl',
                                    block: true,
                                    ...button,
                                }}
                            />
                        ) : null}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
